export default [
  {
    path: '/partner/activation',
    name: 'PartnerActivation',
    component: () => import('@/pages/main/PartnerActivation'),
  },
  {
    path: '/partner/creation',
    name: 'PartnerCreation',
    component: () => import('@/pages/main/PartnerCreation'),
  },
  {
    path: '/partner/transaction-browsing/access',
    name: 'PartnerTransactionBrowsingAccess',
    component: () => import('@/pages/projects/PartnerTransactionBrowsingAccess'),
  },
  {
    path: '/projects',
    name: 'projects',
    component: () => import('@/pages/projects/ProjectList'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/project/create',
    name: 'projectCreate',
    component: () => import('@/pages/projects/ProjectCreate'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/partners',
    name: 'partners',
    component: () => import('@/pages/projects/Partnership'),
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: '/report/generation/:publicId',
    name: 'report.generation',
    component: () => import('@/pages/projects/ReportGeneration'),
    meta: {
      requiresAuth: true,
    },
  },
];
